export default __webpack_public_path__ + "static/media/PITA_logo.e452aaa3.svg";